import { forwardRef } from '@hover/blueprint';
import React from 'react';

import { formatVariationEditDescriptions } from 'src/modules/homeownerApp/components/Products/EditDescriptions';
import type { SwatchLabelProps } from 'src/modules/homeownerApp/components/materialCallouts/SwatchLabel';
import { SwatchLabel } from 'src/modules/homeownerApp/components/materialCallouts/SwatchLabel';
import { useHomeownerTranslate } from 'src/modules/homeownerApp/hooks';
import type { VariationEdit } from 'src/modules/homeownerApp/hooks/useVariationEdits';

export interface VariationEditSwatchLabelProps
  extends Omit<SwatchLabelProps, 'primaryLabel' | 'secondaryLabel'> {
  variationEdit: VariationEdit;
  showTertiaryLabel?: boolean;
}

/**
 * VariationEditSwatchLabel is a wrapper for SwatchLabel using the
 * VariationEdit data source.
 */
export const VariationEditSwatchLabel = forwardRef<
  VariationEditSwatchLabelProps,
  'div'
>(({ variationEdit, showTertiaryLabel = true, ...props }, ref) => {
  const t = useHomeownerTranslate();
  const { primaryLabel, secondaryLabel, tertiaryLabel } =
    formatVariationEditDescriptions(t, variationEdit) ?? {};

  return (
    <SwatchLabel
      primaryLabel={primaryLabel}
      ref={ref}
      secondaryLabel={secondaryLabel}
      tertiaryLabel={showTertiaryLabel ? tertiaryLabel : undefined}
      {...props}
    />
  );
});
